import * as React from "react";
import {Fragment} from "react";
import logo from "../../assets/Logo.svg";

class Header extends React.Component {

	render() {

		const {title} = this.props;

		return (
			<Fragment>
				<div className="container-fluid h-100">
					<div className="row align-items-center h-100">
						<div className="col-md-6 col-8">
							<div className="title">
								<img src={logo} className="brand" alt="..." />
								{title &&
									<h1 className="mb-0"><strong className="text-uppercase">{title.split(' ')[0]}</strong> {title.split(' ')[1]}</h1>
								}
							</div>
						</div>
						{/*<div className="col-6">*/}
						{/*	<div className="row align-items-center">*/}
						{/*		<div className="col-md-6 text-end">*/}
						{/*			<a href="https://www.woundwo.com/">*/}
						{/*				Zurück zu woundwo.com*/}
						{/*			</a>*/}
						{/*		</div>*/}
						{/*		<div className="col-md-6">*/}
						{/*			Lang*/}
						{/*		</div>*/}
						{/*	</div>*/}
						{/*</div>*/}
						<div className="col-md-6 col-4 text-end">
							<a href="https://www.woundwo.com/" className="back-link">
								<i className="fas fa-long-arrow-alt-left" /> <span className="ms-2">Zurück zu woundwo.com</span>
							</a>
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}

export default Header;
